import React, {PropTypes} from 'react';
import config from 'config';
import AbstractEditForm from '../../../common/AbstractEditForm';
import Input from '../../../form/Input';
import RaisedButton from 'material-ui/RaisedButton';
import ImageUpload from '../../../form/ImageUpload';
import {VideoInput} from '../../../form/VideoInput';
import {Container, Row, Col} from 'react-grid-system'
import Countries from '../../../form/Countries';
import RichEditor from '../../../form/RichEditor/index';
import InputToggle from '../../../form/InputToggle';
import VideoCategorySelector from './../VideoCategorySelector'

class VideoOnDemandEditForm extends AbstractEditForm {
  static propTypes = {
    ...AbstractEditForm.propTypes,
    fields: PropTypes.objectOf({
      title: PropTypes.object,
      logo: PropTypes.object,
      video: PropTypes.object,
      countries: PropTypes.object,
      order_number: PropTypes.number,
      trigger_push_notifications: PropTypes.bool,
      push_notifications_triggered: PropTypes.bool,
      category_id: PropTypes.string
    })
  };

  publish = () => {
    return this.props.handleSubmit(async (data) => {
      await this.props.publish(this.props.model, data);
      return this.props.onClose(data.category_id);
    })(this.props.values);
  };

  _checkStartTime(startDate) {
    let {fields: {status, statusType}} = this.props;
    let now = new Date();
    if (startDate.value) {
      return now > startDate.value && status.value !== statusType.value.draft;
    }
  }

  _checkStatusType(status, statusType) {
    switch (status.value) {
      case statusType.value.active:
      case statusType.value.pending:
        return true;
    }
  }

  _streamToggleLabelStatus() {
    let {fields: {vip_only}} = this.props;
    if (vip_only) {
      return vip_only.value ? 'VIP-only ' : 'Free';
    }
  }

  _pushToggleLabelStatus() {
    let { fields: { trigger_push_notifications } } = this.props;
    
      return trigger_push_notifications.value ? 'Send push notifications' : 'Do not send push notifications';
  }

  isSaved() {
    let {model} = this.props;
    if (model)
      if (model.id) return true;
    return false;
  }

  render() {
    let {
      fields: {
        title,
        video,
        logo,
        description,
        vip_only,
        trigger_push_notifications,
        push_notifications_triggered,
        countries,
        category_id
      },
      disabled,
      valid,
      submitting,
      isPublished
    } = this.props;
    
    return (
      <div>
        {this._renderHeader()}
        <form onSubmit={this.processSubmit} style={{padding: 31}}>
          <Container style={{marginLeft: 0, padding: 0}}>
            <Row>
              <Col lg={8} md={10} xs={12}>
                <Row>
                  <Col xs={12}>
                    <Input label="Add Video Title" required
                           disabled={disabled} {...title}/>
                  </Col>
                  <Col xs={12}>
                    <VideoCategorySelector label={'Select category for video'} {...category_id}/>
                  </Col>
                  <Col xs={12}>
                    <VideoInput
                      label='Video'
                      allowedFormats={config.allowedFormats}
                      required
                      size="3GB"
                      screenShotImageSize={config.streamCrop}
                      onScreenShotImage={async (screenShot) => {
                        logo.onChange(screenShot);
                      }}
                      {...video}/>
                  </Col>
                  <Col xs={12}>
                    <ImageUpload
                      label="Video Preview Picture"
                      required
                      imageWidth='auto'
                      imageHeight='300px'
                      disabled={disabled}
                      crop={config.streamCrop}
                      {...logo}
                    />
                  </Col>
                  <Col xs={12}>
                    <RichEditor label='Add Description Text' required
                                disabled={disabled || isPublished} {...description}/>
                  </Col>
                  <Col xs={12}>
                    <Countries
                      label="Geographic Availability"
                      placeholder="Find country"
                      disabled={disabled}
                      required
                      {...countries}
                    />
                  </Col>
                  <Col xs={12}>
                    <InputToggle
                      style={{cursor: 'pointer', marginBottom: 20}}
                      label={this._streamToggleLabelStatus()}
                      {...vip_only}
                      disabled={disabled}
                      labelPosition='right'
                    />
                  </Col>
                  <Col xs={12}>
                  { push_notifications_triggered.value ? <p>Push notifications are triggered<br/></p> : <InputToggle
                      style={{cursor: 'pointer', marginBottom: 20}}
                      label={this._pushToggleLabelStatus()}
                      {...trigger_push_notifications}
                      disabled={disabled}
                      labelPosition='right'
                    /> }
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <RaisedButton secondary={true}
                                  fullWidth={true}
                                  disabled={disabled || !valid || submitting}
                                  onClick={this.publish}
                                  label="Save and Publish"/>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </form>
      </div>
    );
  }
}

export default VideoOnDemandEditForm;





// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/VideoOnDemandEditForm/VideoOnDemandEditForm.js